import { NgModule } from '@angular/core';
import { TranslocoModule } from '@jsverse/transloco';
import { CommonModule } from '@angular/common';

import { ModalModule } from '@ux/components/modal/modal.module';
import { SpecialTravelDataComponent } from '@app/modules/special-travel-data/special-travel-data.component';
import { SpecialTravelDataRoutingModule } from '@app/modules/special-travel-data/special-travel-data.routing.module';

@NgModule({
  declarations: [
    SpecialTravelDataComponent
  ],
  imports: [
    CommonModule,
    TranslocoModule,
    ModalModule,
    SpecialTravelDataRoutingModule
  ]
})
export class SpecialTravelDataModule { }
